import React from "react";
import Select from "react-select/lib/Select";
import { TASK_PROGRESS_TYPES, TASK_STATUS_TYPES } from "./data";

export default function ProgressComponent({ item, onDataChange, index }) {
  const handleOnChange = val => {
    onDataChange(index, val.value, "progress");
  };
  return (
    <div style={{ flexGrow: 1 }}>
      <Select
        options={TASK_PROGRESS_TYPES}
        onChange={handleOnChange}
        value={item.progress}
      />
    </div>
  );
}
